import {
    DateRow,
    PriceRow,
    TextRow,
    SimpleTooltip,
    DisplayIdRow,
    LinkRow,
    DateRowStartEnd,
    PriceInput,
    MinLoader,
    TagComponent,
    FilterTags,
    UnitsRow,
    renderCptCodeAndModifiers,
    ApptDetailRow,
    EditWithIcon,
} from 'components';
import {
    agingEnumsSelector,
    convertHours,
    formatAMPM,
    FindLoad,
    formatServiceCodeLabel,
    Images,
    makeCptServiceOptionId,
    PermissionList,
    RolePermission,
    tagEnums,
    renderClientName,
} from 'utils';
import React from 'react';
import { Checkbox } from '@mui/material';
import { AgingRow } from '../../../components/table/tableRows';
import { canReadTags } from 'store/tags/tag.utils';
import { manageStatusColor } from '../../../utils/hooks/manageStatus';

export const invoiceStatusEnums = {
    PENDING: 'PENDING',
    OPEN: 'OPEN',
    PAID: 'PAID',
    CLOSED: 'CLOSED',
};
export const invoiceTabEnums = {
    INVOICEABLE_APPT: 'INVOICEABLE_APPT',
    PENDING: 'PENDING',
    OPEN: 'OPEN',
    COMPLETED: 'COMPLETED',
};
export const invoiceTabTypes = [
    { title: 'Invoiceable Appts', tabValue: invoiceTabEnums.INVOICEABLE_APPT },
    { title: 'Pending', tabValue: invoiceTabEnums.PENDING },
    { title: 'Open', tabValue: invoiceTabEnums.OPEN },
    { title: 'Completed', tabValue: invoiceTabEnums.COMPLETED },
];

export const GET_ACTION_TYPE = 'GET_INVOICE_PAYMENTS';
export const GENERATE_ACTION_TYPE = 'GET_INVOICES_FOR_GENERATE';
export const GENERATE_INVOICE = 'GENERATE_INVOICE';
export const EDIT_TYPE = 'EDIT_PAYMENT_INVOICE';
export const PAY_IN_FULL_PAYMENT_INVOICE = 'PAY_IN_FULL_PAYMENT_INVOICE';

export const generateInvoiceHead = (handleSelect, fullList, selected) => {
    return [
        {
            renderView: (
                <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                    <Checkbox
                        onClick={(e) => handleSelect(e, '', 'all')}
                        name={'checkBox'}
                        style={{ padding: 0, color: '#0C66E4' }}
                        checked={fullList?.length === selected?.length}
                    />
                </SimpleTooltip>
            ),
            width: '50px',
        },
        { name: '', title: 'Service Code', icon: 'date', custom: false },
        { name: '', title: 'Place of Service', custom: false },
        { name: 'dos', title: 'Service Date', iconType: 'date' },
        { name: '', title: 'Client', custom: false },
        { name: '', title: 'Hours', custom: false },
        { name: '', title: 'Invoice Amount', custom: false },
    ];
};

export const generateInvoiceBody = (handleSelect, fullList, selected, handleEdit) => {
    return [
        {
            button: (handle, item) => (
                <Checkbox
                    onClick={(e) => handleSelect(e, item)}
                    name={'checkBox'}
                    style={{ padding: 0, color: '#0C66E4' }}
                    checked={selected?.includes(item?.id)}
                />
            ),
            notClickable: true,
        },
        { rowText: (item) => <TextRow name={item?.serviceCode ? item?.serviceCode : '--'} /> },
        { rowText: (item) => <TextRow name={item?.placeOfService} /> },
        { rowText: (item) => <DateRow date={item?.dateOfService} /> },
        { rowText: (item) => <TextRow name={item?.client} /> },
        { rowText: (item) => <div>{convertHours(item?.hours)}</div> },
        { rowText: (item) => <PriceRow info={item?.invoiceAmount} /> },
    ];
};

export const openInvoiceHead = [
    { name: 'displayId', searchKey: 'DISPLAY_ID', title: 'Invoice ID', custom: false, width: '130px' },
    { name: 'invoicedDate', title: 'Invoice Date', iconType: 'date', disabled: true },
    { name: 'dos', title: 'DOS', iconType: 'date', disabled: true },
    { name: 'client', rowName: 'clientCode', title: 'Client', custom: false, disabled: true },
    { name: 'totalAMT', title: 'Total AMT', custom: false },
    { name: 'paidAMT', title: 'Pmt. AMT', custom: false },
    { name: 'balance', title: 'Balance', custom: false },
    { name: 'aging', title: 'Aging', width: '100px', disabled: true, iconType: 'date' },
    { name: '', title: 'Tags', custom: false, renderView: <FilterTags /> },
    RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) && {
        name: 'actions',
        title: 'Actions',
        custom: false,
        disabled: true,
        width: '240px',
    },
];

export const invoiceNoYet = {
    title: 'No Invoiceable Appts',
    subTitle: 'There are no invoiceable appts.',
    image: Images.noPendingClaim,
};

export const openInvoiceBody = (
    activeRow,
    setActiveRow,
    selectedId,
    handleChange,
    handleCloseInputs,
    payInFull,
    handleSave,
    requestParams
) => {
    const loadPay = FindLoad(EDIT_TYPE);
    const loadPayInFull = FindLoad(PAY_IN_FULL_PAYMENT_INVOICE);

    return [
        { rowText: (item) => <DisplayIdRow id={item?.displayId ? item?.displayId : '--'} /> },
        { rowText: (item) => <DateRow date={item?.invoiceDate} /> },
        { rowText: (item) => <DateRowStartEnd start={item?.dateRange?.early} end={item?.dateRange?.latest} /> },
        {
            rowText: (item) => (
                <LinkRow
                    name={item?.client?.clientCode ? item?.client?.clientCode : '--'}
                    href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.clientId}` : ''}
                    checkPermission={item?.client?.clientId ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                />
            ),
        },
        { rowText: (item) => <PriceRow info={item?.totalAMT} /> },

        {
            rowText: (item) => (
                <div style={{ padding: '0 0 0 16px' }}>
                    <div
                        className={'invoice-table-input'}
                        style={{
                            background: activeRow?.id === item?.id ? 'white' : 'transparent',
                            borderBottom: activeRow?.id === item?.id ? '1px solid #347AF0' : '1px solid transparent',
                        }}
                    >
                        <PriceInput
                            placeholder={activeRow?.paidAMT === '' ? '0' : ''}
                            name={'paidAMT'}
                            handleChange={(e) => handleChange(e)}
                            value={
                                activeRow?.id === item?.id
                                    ? activeRow?.paidAMT === ''
                                        ? 0
                                        : activeRow?.paidAMT
                                    : item?.paidAMT
                                      ? item?.paidAMT
                                      : 0
                            }
                            disabled={activeRow?.id !== item?.id}
                        />
                    </div>
                </div>
            ),
            padding: '0',
            notClickable: true,
        },
        { rowText: (item) => <PriceRow info={item?.balance} /> },
        { rowText: (item) => <AgingRow count={item?.aging} />, padding: '0' },
        {
            rowText: (item) => <TagComponent userInfo={item} module={tagEnums.INVOICE} requestParams={requestParams} />,
            notClickable: true,
        },
        {
            rowText: (item) => (
                <div
                    className="invoice-table-actions"
                    style={{
                        color: '#51566D',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {activeRow?.id === item?.id ? (
                        <div className="flex-align-center">
                            <button className="save-btn-box" onClick={handleSave}>
                                {activeRow?.id === item?.id && loadPay?.length ? (
                                    <MinLoader margin={'0'} color={'#344054'} position="relative" />
                                ) : (
                                    'Save'
                                )}
                            </button>
                            <button style={{ margin: 0 }} onClick={handleCloseInputs} className="posting-close-btn">
                                <img src={Images.remove} alt="icon" />
                            </button>
                        </div>
                    ) : (
                        <button
                            style={{ opacity: item?.status === invoiceStatusEnums.PAID ? 0.5 : 1 }}
                            disabled={item?.status === invoiceStatusEnums.PAID}
                            className={'edit'}
                            onClick={() => setActiveRow(item)}
                        >
                            <img src={Images.edit} alt="icon" />
                        </button>
                    )}

                    {item?.status !== invoiceStatusEnums.PAID ? (
                        <button onClick={() => payInFull(item)} className={'pay'}>
                            {selectedId?.id === item?.id && loadPayInFull?.length ? (
                                <MinLoader margin={'4px 0 0'} color={'white'} position="relative" />
                            ) : (
                                'Pay in Full'
                            )}
                        </button>
                    ) : (
                        <SimpleTooltip title={<p>{'This invoice has already been paid.'}</p>} placement="top-start">
                            <button style={{ opacity: '0.5' }} className={'pay'}>
                                Pay in Full
                            </button>
                        </SimpleTooltip>
                    )}
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const openInvoicesNotYet = {
    title: 'No Open Invoices',
    subTitle: 'There are no open invoices.',
    image: Images.noPendingClaim,
};

export const postingInvoiceEnums = {
    COMPLETED: 'COMPLETED',
    PAID: 'PAID',
};

export const paidInvoiceHead = [
    { name: 'displayId', searchKey: 'DISPLAY_ID', title: 'Invoice ID', custom: false, width: '130px' },
    { name: 'invoicedDate', title: 'Invoice Date', iconType: 'date', disabled: true },
    { name: 'dos', title: 'DOS', iconType: 'date', disabled: true },
    { name: 'client', rowName: 'clientCode', title: 'Client', custom: false, disabled: true },
    { name: 'totalAMT', title: 'Total AMT', custom: false },
    { name: 'paidAMT', title: 'Pmt. AMT', custom: false },
    { name: 'balance', title: 'Balance', custom: false },
    { name: '', title: 'Tags', custom: false, renderView: <FilterTags /> },
    {
        name: 'status',
        title: 'Status',
        disabled: true,
        width: '75px',
        filterList: [
            { name: 'All', id: 'All' },
            // { name: 'Open', id: 'OPEN' },
            { name: 'Paid', id: invoiceStatusEnums.PAID },
            { name: 'Closed', id: invoiceStatusEnums.CLOSED },
        ],
    },
    RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) && {
        name: 'actions',
        title: 'Actions',
        custom: false,
        disabled: true,
        width: '130px',
    },
];

export const paidInvoiceBody = (
    activeRow,
    setActiveRow,
    selectedId,
    handleChange,
    handleCloseInputs,
    payInFull,
    handleSave,
    requestParams
) => {
    const loadPay = FindLoad(EDIT_TYPE);

    return [
        { rowText: (item) => <DisplayIdRow id={item?.displayId ? item?.displayId : '--'} /> },
        { rowText: (item) => <DateRow date={item?.invoiceDate} /> },
        { rowText: (item) => <DateRowStartEnd start={item?.dateRange?.early} end={item?.dateRange?.latest} /> },
        {
            rowText: (item) => (
                <LinkRow
                    name={item?.client?.clientCode ? item?.client?.clientCode : '--'}
                    href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.clientId}` : ''}
                    checkPermission={item?.client?.clientId ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                />
            ),
        },
        { rowText: (item) => <PriceRow info={item?.totalAMT} /> },

        {
            rowText: (item) => (
                <div style={{ padding: '0 0 0 16px' }}>
                    <div
                        className={'invoice-table-input'}
                        style={{
                            background: activeRow?.id === item?.id ? 'white' : 'transparent',
                            borderBottom: activeRow?.id === item?.id ? '1px solid #347AF0' : '1px solid transparent',
                        }}
                    >
                        <PriceInput
                            placeholder={activeRow?.paidAMT === '' ? '0' : ''}
                            name={'paidAMT'}
                            handleChange={(e) => handleChange(e)}
                            value={
                                activeRow?.id === item?.id
                                    ? activeRow?.paidAMT === ''
                                        ? 0
                                        : activeRow?.paidAMT
                                    : item?.paidAMT
                                      ? item?.paidAMT
                                      : 0
                            }
                            disabled={activeRow?.id !== item?.id}
                        />
                    </div>
                </div>
            ),
            padding: '0',
            notClickable: true,
        },
        { rowText: (item) => <PriceRow info={item?.balance} /> },
        {
            rowText: (item) => <TagComponent userInfo={item} module={tagEnums.INVOICE} requestParams={requestParams} />,
            notClickable: true,
        },
        { rowText: (item) => manageStatusColor(item?.status) },
        {
            rowText: (item) => (
                <div
                    className="invoice-table-actions"
                    style={{
                        color: '#51566D',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {activeRow?.id === item?.id ? (
                        <div className="flex-align-center">
                            <button className="save-btn-box" onClick={handleSave}>
                                {activeRow?.id === item?.id && loadPay?.length ? (
                                    <MinLoader margin={'0'} color={'#344054'} position="relative" />
                                ) : (
                                    'Save'
                                )}
                            </button>
                            <button style={{ margin: 0 }} onClick={handleCloseInputs} className="posting-close-btn">
                                <img src={Images.remove} alt="icon" />
                            </button>
                        </div>
                    ) : (
                        <button
                            style={{ opacity: item?.status === invoiceStatusEnums.PAID ? 0.5 : 1 }}
                            disabled={item?.status === invoiceStatusEnums.PAID}
                            className={'edit'}
                            onClick={() => setActiveRow(item)}
                        >
                            <img src={Images.edit} alt="icon" />
                        </button>
                    )}
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const completedInvoicesNotYet = {
    title: 'No Completed Invoices',
    subTitle: 'There are no completed invoices.',
    image: Images.noPendingClaim,
};


export const invoiceableApptTableInfo = (handleSelect, fullList, selected, globalServices) => {
    return {
        loadingType: GENERATE_ACTION_TYPE,

        head: [
            {
                renderView: (
                    <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                        <Checkbox
                            onClick={(e) => handleSelect(e, '', 'all')}
                            name={'checkBox'}
                            style={{ padding: 0, color: '#0C66E4' }}
                            checked={fullList?.length === selected?.length && !!fullList?.length}
                        />
                    </SimpleTooltip>
                ),
                width: '35px',
            },
            {
                name: 'cptCode',
                searchKey: 'SERVICE_CODE',
                title: 'Service Code',
                // custom: false,

                // noSearch: true,
                multiple: true,
                // returnAllValues: true,
                listWidth: 300,
                // filterList: globalServices?.length ? [{ name: 'All', id: 'All' }, ...globalServices] : [{ name: 'All', id: 'All' }],
                filterList: globalServices?.length
                    ? [
                          { name: 'All', id: 'All' },
                          ...globalServices.map((i) => ({
                              name: `${i?.serviceTypeName} (${i?.cptCode})`,
                              // Encode both cptCode and serviceTypeId so the backend can pair them
                              id: makeCptServiceOptionId(i?.cptCode, i?.serviceTypeId),
                          })),
                      ]
                    : [{ name: 'All', id: 'All' }],

                width: '16%',
            },
            { name: 'placeOfService', title: 'Place of Service', custom: false, width: '16%' },
            { name: 'dos', title: 'Service Date', iconType: 'date', width: '16%' },
            { name: 'client', title: 'Client', custom: false, width: '20%' },
            { name: 'hours', title: 'Hours', custom: false, width: '16%' },
            { name: 'invoiceAmount', title: 'Invoice Amount', custom: false, width: '16%' },
        ],

        body: (item) => [
            {
                value: (
                    <Checkbox
                        onClick={(e) => handleSelect(e, item)}
                        name={'checkBox'}
                        style={{ padding: 0, color: '#0C66E4', marginLeft: '-3px', marginRight: '-1px' }}
                        checked={selected?.includes(item?.id)}
                    />
                ),
                notClickable: true,
                width: '35px',
            },
            { value: <TextRow name={formatServiceCodeLabel(item?.serviceCode, item?.serviceTypeCode) || '--'} />, width: '16%' },
            { value: <TextRow name={item?.placeOfService || '--'} />, width: '16%' },
            { value: <DateRow date={item?.dateOfService} />, width: '16%' },
            { value: <TextRow name={item?.client || '--'} />, width: '20%' },
            { value: <div>{convertHours(item?.hours)}</div>, width: '16%' },
            { value: <PriceRow info={item?.invoiceAmount} />, width: '16%' },
        ],

        renderAccordionRow: (i) => i?.appointments,

        accordionHead: [
            { title: 'Appt ID', width: '15%' },
            { title: 'DOS', width: '15%' },
            { title: 'Time', width: '15%' },
            { title: 'Units/Hours', width: '15%' },
            { title: 'Payer', width: '20%' },
            { title: 'POS', width: '20%' },
        ],

        accordionBody: (appt) => [
            { value: <ApptDetailRow name={appt?.displayId || '--'} id={appt?.id} showWidth={'100%'} />, width: '15%' },
            { value: <DateRow date={appt?.startTime} />, width: '15%' },
            {
                value: appt?.startTime ? `${formatAMPM(appt?.startTime)} - ${formatAMPM(appt?.endTime)}` : '--',
                width: '15%',
            },
            {
                value: (() => {
                    if (!appt?.startTime || !appt?.endTime) return '--';
                    const hours = (new Date(appt.endTime) - new Date(appt.startTime)) / 3600000;
                    return (
                        <div style={{ whiteSpace: 'nowrap', gap: 4 }} className="flex-align-center">
                            <p className="billable-appt-units-units">{hours?.toFixed(1)}</p>
                            <p>({convertHours(hours)})</p>
                        </div>
                    );
                })(),
                width: '15%',
            },
            { value: <TextRow name={appt?.payer || '--'} />, width: '20%' },
            { value: <TextRow name={appt?.placeOfService || '--'} />, width: '20%' },
        ],

        noDetailsText: 'No appointments',
        notYet: invoiceNoYet,
    };
};

/** ─── Shared Accordion Bill Fields (used in Pending, Open, Completed) ── */

const invoiceBillAccordionHead = [
    { title: 'ID', width: '13%' },
    { title: 'DOS', width: '12%' },
    { title: 'CPT Code', width: '13%' },
    { title: 'Units', width: '10%' },
    { title: 'Billed', width: '10%' },
    { title: 'Allowed', width: '10%' },
    { title: 'Client Total', width: '10%' },
    { title: 'Client Paid', width: '10%' },
    { title: 'Client Balance', width: '10%' },
];

const invoiceBillAccordionBody = (bill) => [
    { value: bill?.displayId || '--', width: '13%' },
    { value: <DateRow date={bill?.dos} />, width: '12%' },
    {
        value: (
            <TextRow
                name={renderCptCodeAndModifiers(
                    formatServiceCodeLabel(bill?.cptCode, bill?.serviceTypeCode),
                    bill?.chargeRateModifier,
                    bill?.chargeRateModifier2,
                    bill?.chargeRateModifier3,
                    bill?.posModifier,
                )}
            />
        ),
        width: '13%',
    },
    { value: <UnitsRow info={bill?.totalUnits} />, width: '10%' },
    { value: <PriceRow info={bill?.totalBilled} />, width: '10%' },
    { value: <PriceRow info={bill?.payorTotal || 0} />, width: '10%' },
    { value: <PriceRow info={bill?.clientTotal || 0} />, width: '10%' },
    { value: <PriceRow info={bill?.clientPaid || 0} />, width: '10%' },
    { value: <PriceRow info={bill?.clientBalance} />, width: '10%' },
];

/** ─── Pending Invoice Accordion Table Info ──────────────────────────── */

export const SUBMIT_INVOICES_TYPE = 'SUBMIT_INVOICES';
export const DELETE_INVOICES_BULK_TYPE = 'DELETE_INVOICES_BULK';

export const pendingInvoiceTableInfo = (navigate, info, handleSelect, handleAction, fullList, selected) => {
    const checkPermission = RolePermission([PermissionList.INVOICE_READ?.code]);
    const activeStyles = {
        color: checkPermission ? '#347AF0' : '#4B5C68',
        textDecoration: checkPermission ? 'underline' : 'none',
        width: 'fit-content',
        cursor: checkPermission ? 'pointer' : 'default',
    };

    const handleOpen = (e, id) => {
        if (checkPermission) e.preventDefault();
        e.stopPropagation();
        navigate(`/invoice/${id}`, { state: { tabType: info?.tabType } });
    };

    return {
        loadingType: GET_ACTION_TYPE,

        head: [
            RolePermission([PermissionList.INVOICE_CREATE?.code]) && {
                renderView: (
                    <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                        <Checkbox
                            onClick={(e) => handleSelect(e, '', 'all')}
                            name={'checkBox'}
                            style={{ padding: 0, color: '#0C66E4' }}
                            checked={fullList?.length === selected?.length && !!fullList?.length}
                        />
                    </SimpleTooltip>
                ),
                width: '35px',
            },
            { name: 'displayId', searchKey: 'DISPLAY_ID', title: 'Invoice ID', custom: false, width: '14%' },
            { name: 'invoicedDate', title: 'Invoice Date', iconType: 'date', disabled: true, width: '12%' },
            { name: 'dos', title: 'DOS', iconType: 'date', disabled: true, width: '16%' },
            { name: 'client', rowName: 'clientCode', title: 'Client', custom: false, width: '14%' },
            { name: 'totalAMT', title: 'Total AMT', custom: false, width: '14%' },
            { name: '', title: 'Hours', custom: false, width: '10%' },
            { name: 'balance', title: 'Balance', custom: false, width: '13%' },
            { name: 'action', title: 'Action', custom: false, width: '100px' },
        ],

        body: (item) => [
            RolePermission([PermissionList.INVOICE_CREATE?.code]) && {
                value: (
                    <Checkbox
                        onClick={(e) => handleSelect(e, item)}
                        name={'checkBox'}
                        style={{ padding: 0, color: '#0C66E4', marginLeft: '-3px', marginRight: '-1px' }}
                        checked={selected?.includes(item?.id)}
                    />
                ),
                notClickable: true,
                width: '35px',
            },
            {
                value: (
                    <p style={activeStyles} onClick={(e) => handleOpen(e, item?.id)}>
                        {item?.displayId || '--'}
                    </p>
                    // <p
                    //     style={activeStyles}
                    //     onClick={(e) => {
                    //         e.stopPropagation();
                    //         if (checkPermission) {
                    //             e.preventDefault();
                    //             e.stopPropagation();
                    //             navigate(`/invoice/${item?.id}`, { state: { tabType: info?.tabType } });
                    //         }
                    //     }}>
                    //     <DisplayIdRow id={item?.displayId || '--'} />
                    // </p>
                ),
                notClickable: true,
                width: '14%',
            },
            { value: <DateRow date={item?.invoiceDate} />, width: '12%' },
            { value: <DateRowStartEnd start={item?.dateRange?.early} end={item?.dateRange?.latest} />, width: '16%' },
            {
                value: (
                    <LinkRow
                        name={item?.client ? `(${item?.client?.clientCode}) ${item?.client?.clientFullName}` : item?.client?.code || '--'}
                        href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.clientId}` : ''}
                        checkPermission={item?.client?.clientId ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                    />
                ),
                width: '14%',
            },
            { value: <PriceRow info={item?.totalAMT} />, width: '14%' },
            { value: <div>{convertHours(item?.totalHours)}</div>, width: '10%' },
            { value: <PriceRow info={item?.balance} />, width: '13%' },
            {
                value: <EditWithIcon icon={Images.redTrash} handleClick={() => handleAction(item, 'delete')} />,
                notClickable: true,
                width: '100px',
            },
        ],

        renderAccordionRow: (i) => i?.bills,

        accordionHead: invoiceBillAccordionHead,
        accordionBody: invoiceBillAccordionBody,

        noDetailsText: 'No bills',
        notYet: {
            title: 'No Pending Invoices',
            subTitle: 'There are no pending invoices.',
            image: Images.noPendingClaim,
        },
    };
};

/** ─── Open Invoice Accordion Table Info ─────────────────────────────── */

export const DELETE_OPEN_INVOICES_TYPE = 'DELETE_OPEN_INVOICES_BULK';

export const openInvoiceTableInfo = (navigate, info, handleSelect, handleAction, fullList, selected, payInFullSelectedId, renderParams) => {
    const loadPayInFull = FindLoad('PAY_IN_FULL_PAYMENT_INVOICE');
    const checkPermission = RolePermission([PermissionList.INVOICE_READ?.code]);
    const activeStyles = {
        color: checkPermission ? '#347AF0' : '#4B5C68',
        textDecoration: checkPermission ? 'underline' : 'none',
        width: 'fit-content',
        cursor: checkPermission ? 'pointer' : 'default',
    };

    const handleOpen = (e, id) => {
        if (checkPermission) e.preventDefault();
        e.stopPropagation();
        navigate(`/invoice/${id}`, { state: { tabType: info?.tabType } });
    };

    return {
        loadingType: GET_ACTION_TYPE,

        head: [
            RolePermission([PermissionList.INVOICE_UPDATE?.code]) && {
                renderView: (
                    <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                        <Checkbox
                            onClick={(e) => handleSelect(e, '', 'all')}
                            name={'checkBox'}
                            style={{ padding: 0, color: '#0C66E4' }}
                            checked={fullList?.length === selected?.length && !!fullList?.length}
                        />
                    </SimpleTooltip>
                ),
                width: '35px',
            },
            { name: 'displayId', searchKey: 'DISPLAY_ID', title: 'Invoice ID', width: '7%' },
            { name: 'invoicedDate', title: 'Invoice Date', iconType: 'date', disabled: true, width: '7%' },
            { name: 'dos', title: 'DOS', iconType: 'date', disabled: true, width: '11%' },
            { name: 'client', rowName: 'clientCode', title: 'Client', custom: false, disabled: true, width: '9%' },
            { name: 'totalAMT', title: 'Total AMT', custom: false, width: '8%' },
            { name: 'paidAMT', title: 'Pmt. AMT', custom: false, width: '8%' },
            { name: '', title: 'Adjustments', custom: false, width: '8%' },
            { name: 'balance', title: 'Balance', custom: false, width: '8%' },
            { name: 'aging', title: 'Aging', iconType: 'date', width: '5%' },
            canReadTags() && { name: '', title: 'Tags', custom: false, renderView: <FilterTags />, width: '11%' },
            RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) && {
                name: 'actions',
                title: 'Actions',
                custom: false,
                disabled: true,
                width: '290px',
            },
        ],

        body: (item) => [
            RolePermission([PermissionList.INVOICE_UPDATE?.code]) && {
                value: (
                    <Checkbox
                        onClick={(e) => handleSelect(e, item)}
                        name={'checkBox'}
                        style={{ padding: 0, color: '#0C66E4', marginLeft: '-3px', marginRight: '-1px' }}
                        checked={selected?.includes(item?.id)}
                    />
                ),
                notClickable: true,
                width: '35px',
            },
            {
                value: (
                    <p style={activeStyles} onClick={(e) => handleOpen(e, item?.id)}>
                        {item?.displayId || '--'}
                    </p>
                ),
                notClickable: true,
                width: '7%',
            },
            { value: <DateRow date={item?.invoiceDate} />, width: '7%' },
            { value: <DateRowStartEnd start={item?.dateRange?.early} end={item?.dateRange?.latest} />, width: '11%' },
            {
                value: (
                    <LinkRow
                        // name={item?.client?.clientCode || '--'}
                        name={item?.client ? `(${item?.client?.clientCode}) ${item?.client?.clientFullName}` : item?.client?.code || '--'}
                        href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.clientId}` : ''}
                        checkPermission={item?.client?.clientId ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                    />
                ),
                width: '9%',
            },
            { value: <PriceRow info={item?.totalAMT} />, width: '8%' },
            { value: <PriceRow info={item?.paidAMT} />, width: '8%' },
            { value: <PriceRow info={item?.adjustmentsTotal || 0} />, width: '8%' },
            { value: <PriceRow info={item?.balance} />, width: '8%' },
            { value: <AgingRow count={item?.aging} />, padding: '0', width: '5%' },
            canReadTags() && {
                value: <TagComponent userInfo={item} module={tagEnums.INVOICE} requestParams={renderParams()} />,
                notClickable: true,
                width: '11%',
            },
            RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) && {
                value: (
                    <div className="invoice-table-actions flex-align-center" style={{ gap: 8 }}>
                        <button
                            style={{ margin: 0, width: 95 }}
                            className="pay"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleAction(item, 'payInFull');
                            }}>
                            {payInFullSelectedId === item?.id && loadPayInFull?.length ? (
                                <MinLoader margin={'0'} color={'white'} position="relative" />
                            ) : (
                                'Pay in Full'
                            )}
                        </button>
                        <button
                            style={{ margin: 0 }}
                            className="pay"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleAction(item, 'addTxn');
                            }}>
                            Add Txn
                        </button>
                        <SimpleTooltip
                            title={item?.paidAMT > 0 ? <p>Cannot delete invoice with payments</p> : <p>Delete</p>}
                            placement="top-start">
                            <button
                                className="reset-btn-no-paddings"
                                style={{ opacity: item?.paidAMT > 0 ? 0.3 : 1, cursor: item?.paidAMT > 0 ? 'not-allowed' : 'pointer' }}
                                disabled={item?.paidAMT > 0}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if (item?.paidAMT <= 0) handleAction(item, 'delete');
                                }}>
                                <img src={Images.redTrash} alt="delete" />
                            </button>
                        </SimpleTooltip>
                    </div>
                ),
                notClickable: true,
                width: '290px',
            },
        ],

        renderAccordionRow: (i) => i?.bills,

        accordionHead: invoiceBillAccordionHead,
        accordionBody: invoiceBillAccordionBody,

        noDetailsText: 'No bills',
        notYet: openInvoicesNotYet,
    };
};

/** ─── Completed Invoice Accordion Table Info ────────────────────────── */

export const completedInvoiceTableInfo = (navigate, info, handleAction, renderParams) => {
    const checkPermission = RolePermission([PermissionList.INVOICE_READ?.code]);
    const activeStyles = {
        color: checkPermission ? '#347AF0' : '#4B5C68',
        textDecoration: checkPermission ? 'underline' : 'none',
        width: 'fit-content',
        cursor: checkPermission ? 'pointer' : 'default',
    };


    const handleOpen = (e, id) => {
        if (checkPermission) e.preventDefault();
        e.stopPropagation();
        navigate(`/invoice/${id}`, { state: { tabType: info?.tabType } });
    };


    return {
        loadingType: GET_ACTION_TYPE,

        head: [
            { name: 'displayId', searchKey: 'DISPLAY_ID', title: 'Invoice ID', width: '10%' },
            { name: 'invoicedDate', title: 'Invoice Date', iconType: 'date', disabled: true, width: '10%' },
            { name: 'dos', title: 'DOS', iconType: 'date', disabled: true, width: '14%' },
            { name: 'client', rowName: 'clientCode', title: 'Client', custom: false, disabled: true, width: '11%' },
            { name: 'totalAMT', title: 'Total AMT', custom: false, width: '10%' },
            { name: 'paidAMT', title: 'Pmt. AMT', custom: false, width: '10%' },
            { name: '', title: 'Adjustments', custom: false, width: '10%' },
            { name: 'balance', title: 'Balance', custom: false, width: '10%' },
            canReadTags() && { name: '', title: 'Tags', custom: false, renderView: <FilterTags />, width: '10%' },
            RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) && {
                name: 'actions',
                title: 'Actions',
                custom: false,
                disabled: true,
                width: '180px',
            },
        ],

        body: (item) => [
            {
                value: (
                    <p style={activeStyles} onClick={(e) => handleOpen(e, item?.id)}>
                        {item?.displayId || '--'}
                    </p>
                ),
                notClickable: true,
                width: '10%',
            },
            { value: <DateRow date={item?.invoiceDate} />, width: '10%' },
            { value: <DateRowStartEnd start={item?.dateRange?.early} end={item?.dateRange?.latest} />, width: '14%' },
            {
                value: (
                    <LinkRow
                        // name={item?.client?.clientCode || '--'}
                        name={item?.client ? `(${item?.client?.clientCode}) ${item?.client?.clientFullName}` : item?.client?.code || '--'}
                        href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.client?.clientId}` : ''}
                        checkPermission={item?.client?.clientId ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                    />
                ),
                width: '11%',
            },
            { value: <PriceRow info={item?.totalAMT} />, width: '10%' },
            { value: <PriceRow info={item?.paidAMT} />, width: '10%' },
            { value: <PriceRow info={item?.adjustmentsTotal || 0} />, width: '10%' },
            { value: <PriceRow info={item?.balance} />, width: '10%' },
            canReadTags() && {
                value: <TagComponent userInfo={item} module={tagEnums.INVOICE} requestParams={renderParams()} />,
                notClickable: true,
                width: '10%',
            },
            RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) && {
                value: (
                    <div className="invoice-table-actions">
                        <button
                            className="pay"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleAction(item, 'addTxn');
                            }}>
                            Add Txn
                        </button>
                    </div>
                ),
                notClickable: true,
                width: '180px',
            },
        ],

        renderAccordionRow: (i) => i?.bills,

        accordionHead: invoiceBillAccordionHead,
        accordionBody: invoiceBillAccordionBody,

        noDetailsText: 'No bills',
        notYet: completedInvoicesNotYet,
    };
};
